(function () {
  'use strict';

  const trapFocusHandlers = {};

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
      )
    );
  }

  window.trapFocus = function (container, elementToFocus = container) {
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (e) => {
      if (e.target !== container && e.target !== last && e.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = () => document.removeEventListener('keydown', trapFocusHandlers.keydown);
    trapFocusHandlers.keydown = (e) => {
      if (e.code.toUpperCase() !== 'TAB') return;
      if (e.target === last && !e.shiftKey) { e.preventDefault(); first.focus(); }
      if ((e.target === container || e.target === first) && e.shiftKey) { e.preventDefault(); last.focus(); }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus();
  };

  window.removeTrapFocus = function (elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
  };

  class MenuDrawer {
    constructor() {
      this.drawer = document.getElementById('MenuDrawer');
      this.openBtn = document.querySelector('[data-menu-open]');
      this.closeBtns = document.querySelectorAll('[data-menu-close]');
      if (!this.drawer) return;
      this.openBtn?.addEventListener('click', () => this.open());
      this.closeBtns.forEach((b) => b.addEventListener('click', () => this.close()));
      this.drawer.querySelector('.menu-drawer__overlay')?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') this.close();
      });
    }
    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(this.drawer.querySelector('.menu-drawer__panel'));
    }
    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      removeTrapFocus(this.openBtn);
    }
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
    onButtonClick(e) {
      e.preventDefault();
      const prev = this.input.value;
      if (e.currentTarget.name === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }
      if (prev !== this.input.value) this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  customElements.define('quantity-input', QuantityInput);


  document.addEventListener('DOMContentLoaded', () => {
    new MenuDrawer();
  });
})();
